















































































































import Vue from "vue";
import { authentication } from "@/stores";
import firebaseProject from "@/common/firebaseProject";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import draggable from "vuedraggable";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "AppMenuSetting",
  components: { draggable },
  mixins: [form, autoclose],
  data(): {
    authentication: object;
    transitionName: string;
    listTopItems: any[] | undefined;
    defaultMenuTopList: any[];
    listItems: any[] | undefined;
    defaultMenuList: any[];
  } {
    return {
      authentication,
      transitionName: "",
      listTopItems: undefined,
      defaultMenuTopList: [
        {
          menuType: 1,
          title: "来店予約",
          display: false,
          sort: 3,
          w: "29",
          h: "31",
          icon: "#ic-icon-reservation"
        },
        {
          menuType: 2,
          title: "イベント",
          display: true,
          sort: 2,
          w: "35",
          h: "32",
          icon: "#ic-icon-event"
        },
        {
          menuType: 3,
          title: "チラシ",
          display: false,
          sort: 4,
          w: "24",
          h: "29",
          icon: "#ic-icon-flyer"
        },
        {
          menuType: 4,
          title: "抽選会",
          display: false,
          sort: 5,
          w: "32",
          h: "29",
          icon: "#ic-icon-campaign"
        },
        {
          menuType: 5,
          title: "クーポン",
          display: true,
          sort: 1,
          w: "32",
          h: "26",
          icon: "#ic-icon-coupon"
        },
        {
          menuType: 6,
          title: "お気に入り",
          display: false,
          sort: 6,
          w: "28",
          h: "25",
          icon: "#ic-icon-favorite"
        }
      ],
      listItems: undefined,
      defaultMenuList: [
        {
          menuType: 1,
          title: "来店予約",
          display: false,
          sort: 5,
          w: "29",
          h: "31",
          icon: "#menu-reservation"
        },
        {
          menuType: 2,
          title: "イベント",
          display: true,
          sort: 2,
          w: "33",
          h: "28",
          icon: "#menu-event"
        },
        {
          menuType: 3,
          title: "チラシ",
          display: true,
          sort: 3,
          w: "25",
          h: "31",
          icon: "#menu-flyer"
        },
        {
          menuType: 4,
          title: "抽選会",
          display: false,
          sort: 6,
          w: "30.5",
          h: "27.5",
          icon: "#menu-campaign"
        },
        {
          menuType: 5,
          title: "クーポン",
          display: true,
          sort: 1,
          w: "32",
          h: "26",
          icon: "#menu-coupon"
        },
        {
          menuType: 6,
          title: "お気に入り",
          display: true,
          sort: 4,
          w: "28",
          h: "25",
          icon: "#menu-favorite"
        }
      ]
    };
  },
  async created() {
    this.listTopItems = await db
      .collection(`/shop/${this.shopId}/menuTop`)
      .orderBy("sort", "asc")
      .get()
      .then(snapshot => {
        return snapshot.docs.map(doc => {
          return {
            id: doc.id,
            ...doc.data()
          };
        });
      });
    for (let i = 0; i < this.defaultMenuTopList.length; i++) {
      const defaultMenu = this.defaultMenuTopList[i];
      const data = this.listTopItems?.find(item => {
        return item.menuType == defaultMenu.menuType;
      });
      if (!data) {
        this.listTopItems?.push({
          id: "",
          ...defaultMenu
        });
      }
      this.listTopItems = this.listTopItems?.map(item => {
        if (item.menuType == defaultMenu.menuType) {
          item.title = defaultMenu.title;
          item.icon = defaultMenu.icon;
          item.h = defaultMenu.h;
          item.w = defaultMenu.w;
        }
        return item;
      });
    }
    if (this.listTopItems) {
      this.listTopItems = this.listTopItems.sort((a, b) => {
        if (a.sort > b.sort) return 1;
        if (a.sort < b.sort) return -1;
        return 0;
      });
    }

    this.listItems = await db
      .collection(`/shop/${this.shopId}/menu`)
      .orderBy("sort", "asc")
      .get()
      .then(snapshot => {
        return snapshot.docs.map(doc => {
          return {
            id: doc.id,
            ...doc.data()
          };
        });
      });
    for (let i = 0; i < this.defaultMenuList.length; i++) {
      const defaultMenu = this.defaultMenuList[i];
      const data = this.listItems?.find(item => {
        return item.menuType == defaultMenu.menuType;
      });
      if (!data) {
        this.listItems?.push({
          id: "",
          ...defaultMenu
        });
      }
      this.listItems = this.listItems?.map(item => {
        if (item.menuType == defaultMenu.menuType) {
          item.title = defaultMenu.title;
          item.icon = defaultMenu.icon;
          item.h = defaultMenu.h;
          item.w = defaultMenu.w;
        }
        return item;
      });
    }
    if (this.listItems) {
      this.listItems = this.listItems.sort((a, b) => {
        if (a.sort > b.sort) return 1;
        if (a.sort < b.sort) return -1;
        return 0;
      });
    }
  },
  computed: {
    displayCountTop(): number {
      let displayCount = 0;
      if (this.listTopItems) {
        for (let i = 0; i < this.listTopItems.length; i++) {
          const menu = this.listTopItems[i];
          if (menu.display) {
            displayCount++;
          }
        }
      }
      return displayCount;
    }
  },
  methods: {
    async register() {
      if (this.listTopItems) {
        let displayCount = 0;
        for (let i = 0; i < this.listTopItems.length; i++) {
          const menu = this.listTopItems[i];
          if (menu.display) {
            displayCount++;
          }
        }
        if (displayCount != 2) {
          alert({
            title: "エラー",
            text: "表示するTOPメニューは2つ設定してください"
          });
          return;
        }
      }
      if (this.listTopItems) {
        for (let i = 0; i < this.listTopItems.length; i++) {
          const menu = this.listTopItems[i];
          if (menu.id) {
            await db
              .collection(`/shop/${this.shopId}/menuTop`)
              .doc(menu.id)
              .update({
                display: menu.display,
                sort: i + 1
              });
          } else {
            await db.collection(`/shop/${this.shopId}/menuTop`).add({
              menuType: menu.menuType,
              title: menu.title,
              display: menu.display,
              sort: i + 1
            });
          }
        }
      }
      if (this.listItems) {
        for (let i = 0; i < this.listItems.length; i++) {
          const menu = this.listItems[i];
          if (menu.id) {
            await db
              .collection(`/shop/${this.shopId}/menu`)
              .doc(menu.id)
              .update({
                display: menu.display,
                sort: i + 1
              });
          } else {
            await db.collection(`/shop/${this.shopId}/menu`).add({
              menuType: menu.menuType,
              title: menu.title,
              display: menu.display,
              sort: i + 1
            });
          }
        }
      }
      this.$router.push("/");
    },
    async onEnd(originalEvent: any) {
      console.log("onEnd");
    }
  }
});
